import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allUpdateLog, addUpdateLog,delUpdateLog} from '../../api'
 
   
   
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
   { title: "序号", key: "id", align: "center" },  
    { title: "标题", key: "content", align: "center" },  
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllallUpdateLog = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit };
    allUpdateLog(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllallUpdateLog();
  
  
  const change = (page: any) => {
    getAllallUpdateLog();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 
 

  
  const advertise = reactive({
    id:0,
    key: ""
  })
  
  
  const deleUpdateLog = (row: any) => {
       var data={'id':row.id} 
    delUpdateLog(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllallUpdateLog(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  
  const changeVisible11 = () => {
    advertise.id = 0;
    advertise.key = ""; 
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addUpdateLog(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllallUpdateLog();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false; 
  
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleUpdateLog(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '300px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: advertise,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, { prop: "key" }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入更新内容",
                    modelValue: advertise.key,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((advertise.key) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})